import { useState } from "react";
import type { MenuProps } from "antd";
import { Menu, Drawer } from "antd";
import { AiOutlineMenu, AiOutlineProfile, AiOutlineUser } from "react-icons/ai";
import { Link } from "react-router-dom";
import { useRole } from "../../../hooks/user-roles";
import {
  DatabaseOutlined,
  SettingOutlined,
  TeamOutlined,
} from "@ant-design/icons";

const CBMenu = () => {
  const { canViewAll, isProctor } = useRole();
  const [open, setOpen] = useState(false);
  const showDrawer = () => {
    if (!isProctor) {
      setOpen(true);
    }
  };

  const onClose = () => {
    setOpen(false);
  };

  const onClick: MenuProps["onClick"] = () => {
    setOpen(false);
  };

  const items: MenuProps["items"] = [];

  if (canViewAll) {
    items.push(
      {
        label: <Link to={"/SEABC/courses"}>ALL COURSES</Link>,
        key: "courses",
        icon: <AiOutlineProfile />,
      },
      {
        label: <Link to={"/SEABC/students"}>ALL STUDENTS</Link>,
        key: "students",
        icon: <AiOutlineUser />,
      },
      {
        label: <Link to={"/SEABC/team-members"}>ALL TEAM MEMBERS</Link>,
        key: "team-members",
        icon: <TeamOutlined />,
      },
      {
        label: <Link to={"/SEABC/reports"}>REPORTS & ANALYTICS</Link>,
        key: "reports-analytics",
        icon: <DatabaseOutlined />,
      },
      {
        label: <Link to={"/SEABC/settings"}>SETTINGS</Link>,
        key: "settings",
        icon: <SettingOutlined />,
      },
    );
  } else {
    items.push(
      {
        label: <Link to={"/SEABC/my-courses"}>MY COURSES</Link>,
        key: "my-courses",
        icon: <AiOutlineProfile />,
      },
      {
        label: <Link to={"/SEABC/courses"}>ALL COURSES</Link>,
        key: "courses",
        icon: <AiOutlineProfile />,
      },
      {
        label: <Link to={"/SEABC/settings"}>SETTINGS</Link>,
        key: "settings",
        icon: <SettingOutlined />,
      },
    );
  }

  return (
    <>
      <div className="pt-2" onClick={showDrawer}>
        <AiOutlineMenu className="pt-0 text-2xl" />
      </div>
      <Drawer title="Menu" onClose={onClose} open={open} placement={"left"}>
        <Menu
          className="text-sm"
          onClick={onClick}
          selectedKeys={[]}
          items={items}
        />
      </Drawer>
    </>
  );
};

export default CBMenu;
